import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import getAllSubMenuQuery from './getAllSubMenu.graphql';

const mutation = gql`
  mutation duplicateItem($id: Int) {
    duplicateItem(id: $id) {
      status
      errorMessage
      result {
        id
      }
    }
  }
`;

export default function duplicateItem(id, currentPage, menuId) {
  return async (_dispatch, _getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: { id },
        refetchQueries: [{ query: getAllSubMenuQuery, variables: { currentPage, menuId } }],
        awaitRefetchQueries: true,
      });

      if (data && data.duplicateItem && data.duplicateItem.status === 200) {
        toastr.success('Success', 'Item duplicated successfully.');
        return data.duplicateItem.result && data.duplicateItem.result.id;
      } else {
        const errorMessage = (data && data.duplicateItem && data.duplicateItem.errorMessage) || 'Oops! Something went wrong.';
        toastr.error('Error!', errorMessage);
        return null;
      }
    } catch (err) {
      toastr.error('Error!', err.message || err);
      return null;
    }
  };
}
